import {createContext, useContext} from 'react';
import L from 'leaflet';
import {useMap} from 'react-leaflet';
export type TParkingLots={
	status:boolean,
	content:TParking[]
}
export type TParking = {
	'id': string,
	'name': string,
	'capacity': string,
	'onlineCapacity': string,
	'address': string,
	'x': string,
	'y': string,
	'distance'?: number
}
export type TLatLng = {
	lat: number,
	lng: number
};
export type TLocations = {
	places: string[],
	start: number[],
	stop: number[]
};
export type TAreaLocations = {
	parkingLots: TParking[],
	live?: TLatLng | null | undefined,
	shrine?: TParking
}

export enum LiveFoundObject {
	NotFound = -1,
	Locating,
	Found,
}

type ContextType = {
	map?: L.Map | undefined,
	setMap: (_value: L.Map) => void,
	zoom: number,
	imamRezaShrine: TParking,
	parkingLot?: TParking,
	setParkingLot?: (_value: TParking) => void,
	parkingLots: TParking[],
	setParkingLots?: (_value: TParking[]) => void,
	parkingLotsFilter?: TParking[] | [],
	setParkingLotsFilter?: (_value: TParking[]) => void,
	parkingFilterKey: string,
	setParkingFilterKey?: (_value: string) => void,
	// liveLocation: TLatLng | null,
	// setLiveLocation: (_value: TLatLng) => void,
	// liveFound: LiveFoundObject,
	// setLiveFound: (_value: LiveFoundObject) => void,
	showParkingLots: boolean,
	setShowParkingLots: (_value: boolean) => void,
	latLng: TLatLng,
	setLatLng: (_value: TLatLng) => void,
	openSnack: boolean,
	setOpenSnack: (_value: boolean) => void,
	counter: number,
	setCounter: (_value: number) => void,
	// refetch: () => Promise<void>
	refetch: () => void,
};
const MapContext = createContext<ContextType>({
	setMap: (_value: L.Map) => {
	},
	zoom: 16,
	imamRezaShrine: {
		'id': '',
		'name': '',
		'capacity': '',
		'onlineCapacity': '',
		'address': '',
		'x': '',
		'y': ''
	},
	parkingLot: {
		'id': '',
		'name': '',
		'capacity': '',
		'onlineCapacity': '',
		'address': '',
		'x': '',
		'y': ''
	},
	setParkingLot: (_value: TParking) => {
	},
	parkingLots: [],
	parkingLotsFilter: [],
	parkingFilterKey: 'all',
	// liveLocation: {lat: 36.2884, lng: 59.6157}, //ImamReza Shrine Lat,Lng
	// liveFound: LiveFoundObject.NotFound,
	// setLiveFound: (_value: LiveFoundObject) => {
	// },
	showParkingLots: false,
	setShowParkingLots: (_value: boolean) => {
	},
	// setLiveLocation: (_value: TLatLng) => {
	// },
	latLng: {lat: 36.2884, lng: 59.6157},
	setLatLng: (_value: TLatLng) => {
	},
	openSnack: false,
	setOpenSnack: (_value: boolean) => {
	},
	counter: 60,
	setCounter: (_value: number): void => {
	},
	// refetch: async () => {
	// }
	refetch: (): void => {
	}
});

const useMapContext = () => useContext(MapContext);
export {
	MapContext,
	useMapContext
};
